// extracted by mini-css-extract-plugin
module.exports = {"boundingBox":"FaceDetection_boundingBox__2RJkS"};